import { useTranslation } from 'react-i18next';
import './SdoAdminReportDetailsHeader.scss';
import { useEffect, useState } from 'react';
import { useSdoAdminReportsProvider } from '../../providers/SdoAdminReportsProvider';
import { months } from '../../constants/dates';
import { useProfile } from '../../providers/Profile';
import { getLastPublishedDate } from './SdoAdminReportHelper';
import { getDateInWeekDayMonthDateFormat } from '../../helpers/dateHelpers';
import Loader from '../Loader/Loader';

export default function SdoAdminReportDetailsHeader({ positionsPublishData }) {
  const { t } = useTranslation();
  const sdoAdminReportsContext = useSdoAdminReportsProvider();
  const [sdoMonthYear, setSdoMonthYear] = useState('');
  const profileContext = useProfile();
  const [profile, setProfile] = useState<any>();
  const getTwoDigits = (param) => (param < 10 ? '0' + param : param);

  const getSdoStatus = (status) => {
    switch (status) {
      case 'OPEN':
        return 'sdo-report-details__status--open';
      case 'CLOSED':
        return 'sdo-report-details__status--closed';
      case 'OVERDUE':
        return 'sdo-report-details__status--overdue';
      default:
        return '00778f';
    }
  };

  useEffect(() => {
    if (!profileContext?.profile?.results) return;
    setProfile(profileContext?.profile?.results);
  }, [profileContext.profile]);

  useEffect(() => {
    if (!positionsPublishData) return;

    setSdoMonthYear(
      months[Number(positionsPublishData?.sdoMonth) - 1] +
        ' ' +
        positionsPublishData?.sdoYear
    );
  }, [positionsPublishData]);

  return sdoAdminReportsContext.positionsPublishLoading ? (
    <Loader loaderText="Loading Data" />
  ) : (
    <div className="sdo-report-details-header__container">
      <div className="sdo-report-details__header">
        <div className="sdo-report-details__header--left">
          <h1>
            {t('specialDayOffAdmin.specialDayOffAdminReportDetails.title', {
              monthYear: sdoMonthYear
            })}
          </h1>
          <div className={getSdoStatus(positionsPublishData?.cycleStatus)}>
            <p className="sdo-report-details__header--left-status">
              {positionsPublishData?.cycleStatus ?? ''}
            </p>
          </div>
        </div>
        <div className="sdo-report-details__header--right">
          {/*  need to change below to take last published date  */}
          <span className="sdo-report-header__time">
            {t('specialDayOff.specialDayOffHeader.lastUpdated')}{' '}
            {getDateInWeekDayMonthDateFormat(
              new Date(
                getLastPublishedDate(profile, positionsPublishData?.positions)
              )
            )}{' '}
            {getTwoDigits(
              new Date(
                getLastPublishedDate(profile, positionsPublishData?.positions)
              ).getHours()
            )}
            :
            {getTwoDigits(
              new Date(
                getLastPublishedDate(profile, positionsPublishData?.positions)
              ).getMinutes()
            )}{' '}
            ET
          </span>
          {/* <div className='sdo-report-header__reload' onClick={() => window.location.reload()}> */}
        </div>
      </div>
    </div>
  );
}
